import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-[var(--site-control-height)] w-full rounded-[var(--site-input-radius)] border border-[color:var(--site-border-soft)] bg-[var(--site-surface-strong)] px-[var(--site-input-px)] py-[var(--site-input-py)] text-[length:var(--site-input-font-size)] shadow-[var(--site-shadow-soft)] transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[var(--site-ink-subtle)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-[length:var(--site-input-font-size)]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
